import { TAG_COLORS, TagColorKey } from '../../utils/tagColors';

interface ColorPickerProps {
  value: TagColorKey;
  onChange: (color: TagColorKey) => void;
  disabled?: boolean;
}

const COLOR_ORDER: TagColorKey[] = [
  'red', 'orange', 'amber', 'yellow',
  'lime', 'green', 'emerald', 'teal',
  'cyan', 'sky', 'blue', 'indigo',
  'violet', 'purple', 'fuchsia', 'pink',
  'rose', 'gray'
];

export function ColorPicker({ value, onChange, disabled }: ColorPickerProps) {
  return (
    <div className="grid grid-cols-9 gap-1.5">
      {COLOR_ORDER.map((colorKey) => {
        const color = TAG_COLORS[colorKey];
        const isSelected = value === colorKey;

        return (
          <button
            key={colorKey}
            type="button"
            disabled={disabled}
            onClick={() => onChange(colorKey)}
            className={`w-6 h-6 rounded-full transition-all ${color.dot} ${
              isSelected
                ? 'ring-2 ring-offset-2 ring-gray-900 dark:ring-white dark:ring-offset-gray-800'
                : 'hover:scale-110'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            title={colorKey.charAt(0).toUpperCase() + colorKey.slice(1)}
          />
        );
      })}
    </div>
  );
}

// Inline color dot for display
export function ColorDot({ color, size = 'sm' }: { color: TagColorKey; size?: 'sm' | 'md' | 'lg' }) {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  return (
    <span
      className={`inline-block rounded-full ${sizeClasses[size]} ${TAG_COLORS[color]?.dot || TAG_COLORS.gray.dot}`}
    />
  );
}
